// extracted by mini-css-extract-plugin
export default {"thirdPartyBtnWrapper":"X7-z"};